
export const styles = theme => ({  
  boxImage: {
    margin: -theme.spacing(3)
  }
});